import AdminRoutes from '@admin/routes'
import AuthTemplate from '@auth/components/template'
import AuthRoutes from '@auth/routes'
import NotFound from '@boot/components/NotFound'
import auth from '@boot/middleware/auth'
import loggedIn from '@boot/middleware/loggedIn'
import role from '@boot/middleware/role'
import CustomerRoutes from '@customer/routes'
import GeneralRoutes from '@general/routes'
import ClubRoutes from '@club/routes'
import JuryRoutes from '@jury/routes'
import Router from '@services/router'
import MainTemplate from '@templates/Main'
import { Redirect } from 'react-router-dom'
import Redirect404 from './components/Redirect404'
import React from 'react'

export default Router.create([
    Router.page({ name: "404", path: "/404", component: NotFound }),

    Router.group({ template: AuthTemplate, middleware: auth() }, AuthRoutes),
    Router.group({}, ClubRoutes),
    Router.group({ template: MainTemplate, middleware: loggedIn() }, [
        Router.group({ middleware: role("admin") }, AdminRoutes),
        Router.group({ middleware: role("customer") }, CustomerRoutes),
        Router.group({ middleware: role("jury") }, JuryRoutes)
    ]),
    Router.page({ name: "hack:bl2021", path: "/bl2021", component: () => <Redirect to="/bl" />}), // TODO: it's a hack, delete after beautiful salon 5 finished
    Router.group({}, GeneralRoutes),
    
    Router.notFound({ component: Redirect404 })
])